import { render, staticRenderFns } from "./Live.view.vue?vue&type=template&id=f3d53c76&scoped=true&"
import script from "./Live.view.vue?vue&type=script&lang=js&"
export * from "./Live.view.vue?vue&type=script&lang=js&"
import style0 from "./Live.view.vue?vue&type=style&index=0&id=f3d53c76&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3d53c76",
  null
  
)

export default component.exports